import type React from 'react';
import { Route, Routes } from 'react-router-dom';
import { EditorClient } from './editor-page';
import { ProfileClient } from './profile-page';

export const PersonalClient: React.FC = () => {
  return (
    <Routes>
      <Route index element={<ProfileClient />} />
      <Route path="edit" element={<EditorClient />} />
    </Routes>
  );
};
